import {Component, inject, OnInit} from '@angular/core';
import {DecimalPipe} from "@angular/common";
import {DataService} from "../../services/data.service";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {YesNoPipe} from "../../pipes/yes-no.pipe";

interface StoreData {
    id: string;
    name: string;
    groups: any[];
    checks: any;
    productsCount: number;
}

@Component({
    selector: 'app-product-check',
    imports: [ReactiveFormsModule, FormsModule, DecimalPipe, YesNoPipe],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3><i class="fa-solid fa-boxes-stacked me-2"></i>Produktabgleich</h3>
                </div>

                <div class="input-group mb-3" style="width: 400px">
                    <select class="form-control" style="width: 200px" [(ngModel)]="id_store" (ngModelChange)="loadData()" required>
                        <option value="" disabled selected style="display: none;">Bitte Store oder Alle auswählen</option>
                        <option value="all">Alle</option>
                        @for (store of stores; track store.id) {
                            <option [value]="store.id">{{ store.name }}</option>
                        }
                    </select>
                    <button class="btn btn-primary" type="button" (click)="loadData()">Laden</button>
                </div>

                @if (loading) {
                    <i class="fa fa-spinner fa-spin fa-2x mb-2"></i> Die Daten werden geladen, das kann einige Sekunden dauern...
                }

                @if (storeData.length > 0) {

                    @for (store of storeData; track store.id) {
                        <div class="row">
                            @if (id_store == 'all') {
                                <div class="col mt-3">
                                    <h5>{{ store.name }}</h5>
                                </div>
                            }
                            <div class="col">
                                <div class="alert d-flex align-items-center p-2" [class.alert-success]="store.checks.all_own_exist" [class.alert-warning]="!store.checks.all_own_exist" role="alert">
                                    <i class="fa-solid flex-shrink-0 me-2" [class.fa-check]="store.checks.all_own_exist" [class.fa-warning]="!store.checks.all_own_exist"></i>
                                    <div>
                                        @if (store.checks.all_own_exist) {
                                            Alle Produkte aus der Produktliste sind vorhanden
                                        } @else {
                                            Nicht alle Produkte aus der Produktliste sind vorhanden
                                        }
                                    </div>
                                </div>
                            </div>
                            <div class="col">
                                <div class="alert d-flex align-items-center p-2" [class.alert-success]="store.checks.all_have_article_number" [class.alert-warning]="!store.checks.all_have_article_number" role="alert">
                                    <i class="fa-solid flex-shrink-0 me-2" [class.fa-check]="store.checks.all_have_article_number" [class.fa-warning]="!store.checks.all_have_article_number"></i>
                                    <div>
                                        @if (store.checks.all_have_article_number) {
                                            Alle Produkte haben eine Artikelnummer
                                        } @else {
                                            Nicht alle Produkte haben eine Artikelnummer
                                        }
                                    </div>
                                </div>
                            </div>
                            <div class="col">
                                <div class="alert d-flex align-items-center p-2" [class.alert-success]="store.checks.all_known" [class.alert-warning]="!store.checks.all_known" role="alert">
                                    <i class="fa-solid flex-shrink-0 me-2" [class.fa-check]="store.checks.all_known" [class.fa-warning]="!store.checks.all_known"></i>
                                    <div>
                                        @if (store.checks.all_known) {
                                            Es gibt nur Produkte aus der Produktliste
                                        } @else {
                                            Es gibt Produkte aus der Produktliste und Weitere
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        @if (id_store != 'all') {
                            <p>Es wurden {{ store.productsCount }} Produkte in {{ store.groups.length }} Produktgruppen gefunden!</p>

                            @for (group of store.groups; track group) {
                                <h5>{{ group.productgroup_name }} <small>({{ group.products.length }})</small></h5>

                                @if (group.products.length > 0) {
                                    <div class="table-responsive">
                                        <table class="table table-striped table-hover pointer">
                                            <thead>
                                            <tr>
                                                <th style="width: 170px">
                                                    Artikelnummer
                                                </th>
                                                <th>
                                                    Name
                                                </th>
                                                <th style="width: 140px">
                                                    Aktiv
                                                </th>
                                                <th class="text-end" style="width: 140px">
                                                    Preis (€)
                                                </th>
                                                <th class="text-end" style="width: 140px">
                                                    Steuer (%)
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                                @for (product of group.products; track product) {
                                                    <tr>
                                                        <td>
                                                            {{ product.product_itemnumber }}
                                                            @if (!product.product_itemnumber) {
                                                                <span class="text-danger">Nicht gesetzt</span>
                                                            }
                                                        </td>
                                                        <td>
                                                            {{ product.product_name }}
                                                        </td>
                                                        <td>
                                                            {{ product.product_active | yesNo }}
                                                        </td>
                                                        <td class="text-end">
                                                            {{ product.product_price | number: '1.2-2' }}
                                                        </td>
                                                        <td class="text-end">
                                                            {{ product.product_vat }}
                                                        </td>
                                                    </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                } @else {
                                    <div class="my-3 text-danger">Keine Produkte vorhanden</div>
                                }
                            }
                        }
                    }
                }
            </div>
        </div>
    `
})
export class ProductCheck implements OnInit {

    private dataService = inject(DataService);

    storeData: StoreData[] = [];

    loading = false;

    stores!: any[];
    id_store = '';

    ngOnInit(): void {
        this.dataService.request("Store/listForSelection").subscribe(response => {
            this.stores = response.stores.filter((store: any) => store.account_token != null);
        })
    }

    loadData(): void {
        this.storeData = [];
        this.loading = true;

        if (this.id_store === 'all') {
            this.stores.forEach(store => {
                this.loadDataForStore(store.id);
            })
        } else {
            this.loadDataForStore(this.id_store);
        }
    }

    loadDataForStore(id_store: any): void {
        this.loading = true;

        this.dataService.request('Product/getOverview', {
            id_store: id_store,
        }).subscribe(response => {

            this.storeData.push(response)

            if (this.id_store === 'all') {
                if (this.stores.length === this.storeData.length) {
                    this.loading = false;
                }
            } else {
                this.loading = false;
            }
        });
    }
}
